import React, { useState } from 'react';
import Lottie from 'lottie-react';
import ServiceAnimation from '../assets/what_we_do_profit_grawth.json';
import TargetAnimation from '../assets/target.json';

const WhatWeDo = () => {
    const [selectedTab, setSelectedTab] = useState("vision");

    const content = {
        vision: [
            "At Lavanya Infotech, our vision is to be recognized globally as a trusted technology partner that transforms ideas into impactful digital solutions.",
            "We aim to drive innovation across industries by delivering intelligent, intuitive, and scalable products that simplify operations, elevate customer experiences, and fuel business growth.",
            "We envision a digitally empowered future where technology bridges gaps, empowers communities, and opens new possibilities for every business, regardless of size or location."
        ],
        mission: [
            "To help organizations thrive in the digital age by offering full-cycle technology services—from strategy and design to development and support.",
            "Understand each client's unique needs and craft tailored, result-oriented solutions.",
            "Deliver robust e-commerce platforms, enterprise apps, mobile solutions, and integrated systems.",
            "Ensure reliability, security, and user-friendly experiences in every product.",
            "Build lasting relationships through transparent communication and timely delivery.",
            "Empower businesses to innovate, adapt, and lead using agile methods and quality focus."
        ],
        values: [
            "Integrity – We operate with honesty, ethics, and respect, fostering trust in every relationship.",
            "Innovation – We embrace change, encourage creativity, and invest in R&D to stay ahead.",
            "Customer First – We prioritize understanding and exceeding client expectations.",
            "Excellence – We uphold high standards, continuously improving everything we do.",
            "Teamwork – We believe in collective effort and diverse talent synergy.",
            "Sustainability – We build solutions that are efficient, responsible, and long-term focused.",
            "Accountability – We own our actions, deliver on promises, and grow from experiences."
        ],
    };

    return (
        <div className="bg-black xyz text-white xl:px-20 px-10 md:px-8 py-16 text-center ">
            {/* WHAT WE DO Section */}
            <div className="flex flex-col lg:flex-row items-center gap-10">
                {/* Lottie Animation - Service */}
                <div className="flex justify-center lg:w-1/2">
                    <div className="w-[300px] sm:w-[350px] md:w-[450px] lg:w-[550px] glow-effect">
                        <Lottie animationData={ServiceAnimation} loop={true} />
                    </div>
                </div>

                {/* Text */}
                <div className="lg:w-1/2">
                    <h2 className="text-[#f6f4d2] text-3xl sm:text-4xl font-bold mb-4">What We Do?</h2>
                    <p className="text-gray-300 leading-relaxed text-sm sm:text-base">
                        Lavanya Infotech Private Limited is a dynamic technology company specializing in comprehensive e-commerce solutions for businesses worldwide.
                        Our team of experienced professionals is committed to harnessing the power of technology to overcome business challenges and deliver customized, client-centric solutions.
                        We offer a wide range of services including website design and development, payment gateway integration, inventory and order management systems, and end-to-end e-commerce platform development.
                        At Lavanya Infotech, we believe in building lasting relationships through exceptional customer service and reliable support.
                        Our collaborative approach ensures that our clients' e-commerce operations are optimized for maximum performance, efficiency, and growth.
                    </p>
                </div>
            </div>

            {/* VISION / MISSION / VALUES Section */}
            <div className="flex flex-col-reverse lg:flex-row items-center gap-10 mt-20">
                {/* Text Section */}
                <div className="lg:w-1/2">
                    <h2 className="text-white text-xl sm:text-2xl font-bold mb-4">
                        We really <span className="text-[#f6f4d2]">DO</span> it rather than just say it.
                    </h2>

                    {/* Tabs */}
                    <div className="flex flex-wrap justify-center gap-3 mb-6">
                        <button
                            onClick={() => setSelectedTab("vision")}
                            className={`text-white text-sm px-4 py-2 rounded-md font-medium ${selectedTab === "vision" ? "bg-blue-600" : "bg-gray-700"}`}
                        >
                            Vision
                        </button>
                        <button
                            onClick={() => setSelectedTab("mission")}
                            className={`text-white text-sm px-4 py-2 rounded-md font-medium ${selectedTab === "mission" ? "bg-sky-500" : "bg-gray-700"}`}
                        >
                            Mission
                        </button>
                        <button
                            onClick={() => setSelectedTab("values")}
                            className={`text-white text-sm px-4 py-2 rounded-md font-medium ${selectedTab === "values" ? "bg-blue-300" : "bg-gray-700"}`}
                        >
                            Core values
                        </button>
                    </div>

                    {/* Dynamic Content */}
                    <ul className="list-disc justify-center text-sm text-gray-300 pl-5 space-y-3 text-left sm:pl-0">
                        {content[selectedTab].map((item, index) => (
                            <li key={index}>{item}</li>
                        ))}
                    </ul>
                </div>

                {/* Target Lottie Animation */}
                <div className="flex justify-center lg:w-1/2">
                    <div className="w-[300px] sm:w-[350px] md:w-[400px] lg:w-[450px] glow-effect">
                        <Lottie animationData={TargetAnimation} loop={true} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WhatWeDo;
